export enum SCROLL_TYPE_ENUMS {
  TOP = 'top',
  BOTTOM = 'bottom'
}
export default function useScrollHook() {
  const contentRef = ref<HTMLElement>(null) // 内容区域的ref

  // 内容区域滚动一屏的距离：向上或者向下
  const scrollTo = (type: SCROLL_TYPE_ENUMS) => {
    const scrollAmount = window.innerHeight // 获取一屏的高度
    const currentScroll = contentRef.value?.scrollTop || window.scrollY // 获取当前的滚动位置
    // 计算当前是在第几屏
    const currentScrollCount = Math.floor(currentScroll / scrollAmount)
    const scrollToPosition = Math.max(
      0,
      type === SCROLL_TYPE_ENUMS.TOP
        ? (currentScrollCount - 1) * scrollAmount // 滚动到上方一屏
        : (currentScrollCount + 1) * scrollAmount // 滚动到下方一屏
    )
    ;(contentRef.value || window).scrollTo({
      top: scrollToPosition, // 滚动到上方一屏
      behavior: 'smooth' // 平滑滚动
    })
  }

  // PC:监听内容区域鼠标滚动事件
  const handleScroll = (event: WheelEvent) => {
    event.preventDefault() // 阻止默认事件
    scrollTo(event.deltaY < 0 ? SCROLL_TYPE_ENUMS.TOP : SCROLL_TYPE_ENUMS.BOTTOM)
  }

  // 移动端:监听内容区域touchmove事件
  const initialX = ref(null)
  const initialY = ref(null)
  const currentX = ref(null)
  const currentY = ref(null)
  const swipeThreshold = 50 // 滑动阈值，可以根据需要调整
  // 触点初始位置
  const handleTouchStart = (event) => {
    const touch = event.touches[0]
    initialX.value = touch.clientX
    initialY.value = touch.clientY
  }

  const handleTouchMove = (event: TouchEvent) => {
    event.preventDefault() // 阻止默认事件
    if (!initialX.value) return
    const touch = event.touches[0]
    currentX.value = touch.clientX
    currentY.value = touch.clientY
  }

  const handleTouchEnd = () => {
    if (!initialX.value || !currentX.value) return
    const dx = currentX.value - initialX.value
    const dy = currentY.value - initialY.value

    // 判断滑动方向
    if (Math.abs(dx) > Math.abs(dy)) {
      // 水平滑动
      if (dx > swipeThreshold) {
        // 向右滑动
      } else if (dx < -swipeThreshold) {
        // 向左滑动
      }
    } else {
      // 垂直滑动
      scrollTo(dy > swipeThreshold ? SCROLL_TYPE_ENUMS.TOP : SCROLL_TYPE_ENUMS.BOTTOM)
    }

    // 重置触摸位置
    initialX.value = null
    initialY.value = null
    currentX.value = null
    currentY.value = null
  }

  return {
    contentRef,
    scrollTo,
    handleScroll,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd
  }
}
